import {
  ACCORDION_PANEL_STYLE_SCHEMA,
  normalizeAccordionPanelProps,
} from './accordionPanelProps';
import { siteValuesFromDocument } from '../../theme/styleSchema';

/**
 * Box « Volet » du document → props du bloc web `AccordionPanel`.
 *
 * Les props COMMUNES de la box sont recopiées telles quelles : c'est tout
 * l'intérêt de les stocker aux noms de props du site. Ce qui n'appartient
 * qu'au document (couleurs de texte) reste sur place, et ce qui n'appartient
 * qu'au site (`openBehavior`) garde le défaut du bloc. Seuls le texte
 * (Draft → HTML) et l'alignement (chrome du document → props du bloc)
 * demandent une traduction, et les deux sont injectés par l'appelant — ce
 * module ne connaît ni Draft.js ni le parser.
 *
 * @param {object} box box du document (`content.panel`, `content.*Raw`)
 * @param {(raw: string) => string} toHtml conversion Draft brut → HTML
 * @param {{ horizontal: string, vertical: string }} positions alignement résolu
 * @returns {object} props du bloc, prêtes à poser dans le web_data
 */
export function accordionPanelPropsFromBox(box, { toHtml, positions }) {
  // Filtre volontairement étroit : la box porte aussi des réglages propres au
  // document (couleurs de départ des textes). Seules les props communes
  // traversent, converties s'il le faut (cf. le schéma).
  const style = box?.content?.panel;
  const shared = siteValuesFromDocument(ACCORDION_PANEL_STYLE_SCHEMA, style);
  const resolved = normalizeAccordionPanelProps(shared);

  return {
    ...resolved,
    question: toHtml(box?.content?.questionRaw) || '',
    answer: toHtml(box?.content?.answerRaw) || '',
    alignHorizontal: positions?.horizontal || resolved.alignHorizontal,
    alignVertical: positions?.vertical || resolved.alignVertical,
  };
}

/**
 * Un volet sans question NI réponse n'a rien à rendre sur le site : le parser
 * l'ignore, comme il ignore un texte vide.
 */
export function isEmptyAccordionPanelProps(props) {
  return !props.question.trim() && !props.answer.trim();
}
